"use strict";

var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompositionManagerProvider = exports.compositionsRef = exports.CompositionManager = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importStar(require("react"));

exports.CompositionManager = (0, react_1.createContext)({
  compositions: [],
  registerComposition: function registerComposition() {
    return undefined;
  },
  unregisterComposition: function unregisterComposition() {
    return undefined;
  },
  registerFolder: function registerFolder() {
    return undefined;
  },
  unregisterFolder: function unregisterFolder() {
    return undefined;
  },
  currentComposition: null,
  setCurrentComposition: function setCurrentComposition() {
    return undefined;
  },
  setCurrentCompositionMetadata: function setCurrentCompositionMetadata() {
    return undefined;
  },
  registerSequence: function registerSequence() {
    return undefined;
  },
  unregisterSequence: function unregisterSequence() {
    return undefined;
  },
  registerAsset: function registerAsset() {
    return undefined;
  },
  unregisterAsset: function unregisterAsset() {
    return undefined;
  },
  sequences: [],
  assets: [],
  folders: [],
  currentCompositionMetadata: null
});
exports.compositionsRef = react_1.default.createRef();

var CompositionManagerProvider = function CompositionManagerProvider(_ref) {
  var children = _ref.children;

  // Wontfix, expected to have
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var _ref2 = (0, react_1.useState)([]),
      _ref3 = _slicedToArray(_ref2, 2),
      compositions = _ref3[0],
      setCompositions = _ref3[1];

  var _ref4 = (0, react_1.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      currentComposition = _ref5[0],
      setCurrentComposition = _ref5[1];

  var _ref6 = (0, react_1.useState)([]),
      _ref7 = _slicedToArray(_ref6, 2),
      assets = _ref7[0],
      setAssets = _ref7[1];

  var _ref8 = (0, react_1.useState)([]),
      _ref9 = _slicedToArray(_ref8, 2),
      folders = _ref9[0],
      setFolders = _ref9[1];

  var _ref10 = (0, react_1.useState)([]),
      _ref11 = _slicedToArray(_ref10, 2),
      sequences = _ref11[0],
      setSequences = _ref11[1];

  var _ref12 = (0, react_1.useState)(null),
      _ref13 = _slicedToArray(_ref12, 2),
      currentCompositionMetadata = _ref13[0],
      setCurrentCompositionMetadata = _ref13[1];

  var registerComposition = (0, react_1.useCallback)(function (comp) {
    setCompositions(function (comps) {
      if (comps.find(function (c) {
        return c.id === comp.id;
      })) {
        throw new Error("Multiple composition with id ".concat(comp.id, " are registered."));
      }

      return [].concat(_toConsumableArray(comps), [comp]).slice().sort(function (a, b) {
        return a.nonce - b.nonce;
      });
    });
  }, []);
  var registerSequence = (0, react_1.useCallback)(function (seq) {
    setSequences(function (seqs) {
      return [].concat(_toConsumableArray(seqs), [seq]);
    });
  }, []);
  var unregisterComposition = (0, react_1.useCallback)(function (id) {
    setCompositions(function (comps) {
      return comps.filter(function (c) {
        return c.id !== id;
      });
    });
  }, []);
  var unregisterSequence = (0, react_1.useCallback)(function (seq) {
    setSequences(function (seqs) {
      return seqs.filter(function (s) {
        return s.id !== seq;
      });
    });
  }, []);
  var registerAsset = (0, react_1.useCallback)(function (asset) {
    setAssets(function (assts) {
      return [].concat(_toConsumableArray(assts), [asset]);
    });
  }, []);
  var unregisterAsset = (0, react_1.useCallback)(function (id) {
    setAssets(function (assts) {
      return assts.filter(function (a) {
        return a.id !== id;
      });
    });
  }, []);
  var registerFolder = (0, react_1.useCallback)(function (name, parent) {
    setFolders(function (prevFolders) {
      return [].concat(_toConsumableArray(prevFolders), [{
        name: name,
        parent: parent
      }]);
    });
  }, []);
  var unregisterFolder = (0, react_1.useCallback)(function (name, parent) {
    setFolders(function (prevFolders) {
      return prevFolders.filter(function (p) {
        return !(p.name === name && p.parent === parent);
      });
    });
  }, []);
  (0, react_1.useLayoutEffect)(function () {
    if (typeof window !== 'undefined') {
      window.remotion_collectAssets = function () {
        setAssets([]); // clear assets at next render

        return assets;
      };
    }
  }, [assets]);
  (0, react_1.useImperativeHandle)(exports.compositionsRef, function () {
    return {
      getCompositions: function getCompositions() {
        return compositions;
      }
    };
  }, [compositions]);
  var contextValue = (0, react_1.useMemo)(function () {
    return {
      compositions: compositions,
      registerComposition: registerComposition,
      unregisterComposition: unregisterComposition,
      currentComposition: currentComposition,
      setCurrentComposition: setCurrentComposition,
      registerSequence: registerSequence,
      unregisterSequence: unregisterSequence,
      registerAsset: registerAsset,
      unregisterAsset: unregisterAsset,
      sequences: sequences,
      assets: assets,
      folders: folders,
      registerFolder: registerFolder,
      unregisterFolder: unregisterFolder,
      currentCompositionMetadata: currentCompositionMetadata,
      setCurrentCompositionMetadata: setCurrentCompositionMetadata
    };
  }, [compositions, registerComposition, unregisterComposition, currentComposition, registerSequence, unregisterSequence, registerAsset, unregisterAsset, sequences, assets, folders, registerFolder, unregisterFolder, currentCompositionMetadata]);
  return (0, jsx_runtime_1.jsx)(exports.CompositionManager.Provider, {
    value: contextValue,
    children: children
  });
};

exports.CompositionManagerProvider = CompositionManagerProvider;